import React, { useState, useEffect, useRef} from "react";
import "../styles/NewlyAddedClients.css";

const featuredClient = {
  id: 1,
  name: "KINET RAILWAY SOLUTION LTD",
  location: "Latur, Maharashtra",
  peopleServed: 1500,
  logo: "/newlyaddedclients/Kinet-Railway-Solutions-1.png",
  industry: "Railway Engineering and Manufacturing"
};

const mantriGroup = [
  {
    id: 2,
    name: "MANTRI METALLICS PVT LTD",
    location: "Mumbai, Kagal - MIDC",
    peopleServed: 500,
    logo: "/newlyaddedclients/Mantri-metallics.png",
    industry: "Manufacturing"
  },
  {
    id: 3,
    name: "MANTRI Auto Components PVT. LTD",
    location: "Mumbai, Kagal - MIDC",
    peopleServed: 200,
    logo: "/newlyaddedclients/Mantri-auto.png",
    industry: "Automotive and Manufacturing"
  }
];

const otherClients = [
  {
    id: 4,
    name: "NIRMAL POLY PLAST PVT. LTD",
    location: "Angam (Unit-1), Gujarat",
    peopleServed: 500,
    logo: "/newlyaddedclients/Nirmal-Poly-Plastic.png",
    industry: "Manufacturing industry"
  },
  {
    id: 5,
    name: "PAPRO INDUSTRIES",
    location: "Sanjan, Gujarat",
    peopleServed: 200,
    logo: "/newlyaddedclients/Papro-industries.png",
    industry: "Industrial"
  }
];

function NewlyAddedClients() {

  const [counts, setCounts] = useState({});
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const animateCounters = () => {
      const allClients = [
        featuredClient,
        ...mantriGroup,
        ...otherClients
      ];

      allClients.forEach((client) => {
        let start = 0;
        const end = client.peopleServed;
        const duration = 2000;
        const increment = end / (duration / 16);

        const timer = setInterval(() => {
          start += increment;
          if (start >= end) {
            setCounts((prev) => ({ ...prev, [client.id]: end }));
            clearInterval(timer);
          } else {
            setCounts((prev) => ({ ...prev, [client.id]: Math.floor(start) }));
          }
        }, 16);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            animateCounters();
            setHasAnimated(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    <section className="tsc-section" ref={sectionRef}>
      <div className="tsc-container">
        <div className="tsc-header">
          <h2 className="tsc-title">Newly Onboarded Industrial Partners</h2>
          <p className="tsc-subtitle">
             Proud to serve these distinguished manufacturers with exceptional Industrial catering excellence across India
          </p>
        </div>

        <div className="tsc-featured-card">
          <div className="tsc-featured-badge">
            <svg className="tsc-badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
            FEATURED PARTNER
          </div>
          <div className="tsc-featured-content">
            <div className="tsc-featured-logo-section">
              {featuredClient.logo && (
                <div className="tsc-featured-logo-wrapper">
                  <img
                    src={featuredClient.logo}
                    alt={`${featuredClient.name} Logo`}
                    className="tsc-featured-logo"
                  />
                </div>
              )}
            </div>
            <div className="tsc-featured-details">
              <h3 className="tsc-featured-name">{featuredClient.name}</h3>
              <p className="tsc-featured-industry">{featuredClient.industry}</p>
              <div className="tsc-featured-meta">
                <div className="tsc-featured-location">
                  <svg className="tsc-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                  <span>{featuredClient.location}</span>
                </div>
                <div className="tsc-featured-serving">
                  <svg className="tsc-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"/>
                  </svg>
                  <span className="tsc-featured-count">
                    {counts[featuredClient.id] || 0}
                  </span>
                  <span className="tsc-serving-text">People Serving Daily</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tsc-mantri-group">
          <div className="tsc-group-header">
            <h3 className="tsc-group-title">Mantri Group</h3>
            <div className="tsc-group-badge">2 Manufacturing Units</div>
          </div>
          <div className="tsc-mantri-cards">
            {mantriGroup.map((client) => (
              <div key={client.id} className="tsc-mantri-card">
                <div className="tsc-new-badge">NEW</div>
                {client.logo && (
                  <div className="tsc-mantri-logo-wrapper">
                    <img
                      src={client.logo}
                      alt={`${client.name} Logo`}
                      className="tsc-mantri-logo"
                    />
                  </div>
                )}
                <div className="tsc-mantri-details">
                  <h4 className="tsc-mantri-name">{client.name}</h4>
                  <p className="tsc-mantri-location">
                    <svg className="tsc-icon-small" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                    <span>{client.location}</span>
                  </p>
                  <div className="tsc-mantri-serving">
                    <svg className="tsc-icon-small" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"/>
                    </svg>
                    <span className="tsc-mantri-count">
                      {counts[client.id] || 0}
                    </span>
                    <span>People Serving</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="tsc-other-clients">
          {otherClients.map((client) => (
            <div key={client.id} className="tsc-standard-card">
              <div className="tsc-new-badge">NEW</div>
              <div className="tsc-standard-header">
                {client.logo && (
                  <div className="tsc-standard-logo-wrapper">
                    <img
                      src={client.logo}
                      alt={`${client.name} Logo`}
                      className="tsc-standard-logo"
                    />
                  </div>
                )}
                <div className="tsc-standard-title-section">
                  <h4 className="tsc-standard-name">{client.name}</h4>
                  <p className="tsc-standard-industry">{client.industry}</p>
                </div>
              </div>
              <div className="tsc-standard-info">
                <div className="tsc-standard-location">
                  <svg className="tsc-icon-small" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                  <span>{client.location}</span>
                </div>
                <div className="tsc-standard-serving">
                  <svg className="tsc-icon-small" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"/>
                  </svg>
                  <span className="tsc-standard-count">
                    {counts[client.id] || 0}
                  </span>
                  <span>People Serving</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NewlyAddedClients;